// File: frontend/src/components/ui/LiveTag.js
//
// THE LIVE MARK — the Router Dashboard's pill, as one component.
//
// A figure that ignores the selected dates (a balance, a count of who is online
// right now, what agents owe today) says so with the literal word LIVE, never
// with a colour alone (§20). It lived inline in KpiCard, so any figure that was
// not a KpiCard — the "Agents still owe" position on Financials Overview — had
// no way to carry it. Same pill, same tokens, wherever it is needed.

import React, { useMemo } from "react";
import { Box, useTheme } from "@mui/material";
import makeTokens from "../dashboard/dashboardTokens";

export default function LiveTag({ sx }) {
  const theme = useTheme();
  const G = useMemo(() => makeTokens(theme.palette.mode), [theme.palette.mode]);
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex", alignItems: "center", gap: 0.35, flexShrink: 0,
        px: 0.55, py: 0.15, borderRadius: 99, verticalAlign: "middle",
        bgcolor: G.greenDim, border: `1px solid ${G.greenBdr}`,
        ...sx,
      }}
    >
      <Box component="span" aria-hidden sx={{ width: 4, height: 4, borderRadius: "50%", bgcolor: G.green }} />
      <Box component="span" sx={{ fontSize: 8.5, fontWeight: 800, letterSpacing: "0.09em", color: G.greenText, lineHeight: 1.5, fontFamily: G.fontDisplay }}>
        LIVE
      </Box>
    </Box>
  );
}
